export default {
  SET_HEADER_LINK_BACK: '@@header-link-back/SET_HEADER_LINK_BACK',
  CLEAR_HEADER_LINK_BACK: '@@header-link-back/CLEAR_HEADER_LINK_BACK',
  SET_HEADER_LINK_BLOCKED: '@@header-link-back/SET_HEADER_LINK_BLOCKED',
};
